import { rating_classification } from 'utils/getRatingClassification';

import * as S from './styles';

interface RatingProps {
  nota: number;
}

export function Rating({ nota }: RatingProps) {
  const notaMediaInt = Number(nota.toString().split('.')[0]);
  const notaMediaDec = Number(nota.toString().split('.')[1]) || 0;

  const productRating = rating_classification[notaMediaInt]?.stars.map(
    star => star,
  );

  if (notaMediaDec !== 0) productRating[notaMediaInt] = 1;

  return (
    <S.Container className="rating">
      <div className="stars">
        {productRating.map((star, index) =>
          star === 0 ? (
            <img
              src="/images/icons/reg-star.svg"
              alt="Estrela"
              className="icon regStar-icon"
              key={index}
            />
          ) : star === 1 ? (
            <img
              src="/images/icons/reg-half-star.svg"
              alt="Estrela"
              className="icon regHalfStar-icon"
              key={index}
            />
          ) : (
            <img
              src="/images/icons/star.svg"
              alt="Estrela"
              className="icon star-icon"
              key={index}
            />
          ),
        )}
      </div>
    </S.Container>
  );
}
